// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__1AF3t","button":"style_button__2j5xk","completeIssue":"style_completeIssue__2fK00"};